import React from 'react';
import {csvFileDownload} from '../../utils/streanCsv';
import { DownloadIcon } from '../icons';

// DownloadButton Component
const DownloadButton = ({ label, fileUrl }) => {
    return (
        <button
            type="button"
            className="btn btn-primary"
            onClick={() => csvFileDownload(fileUrl)}
        >
            <DownloadIcon />
            {label}
        </button>
    );
};


export default DownloadButton;
